import React, { Fragment } from 'react'
import "../../css/Home/About.css"
import innovationPic from "../../assets/images/pictograms/innovation.svg"
import devskillsPic from "../../assets/images/pictograms/devskills.svg"
import workexperiencePic from "../../assets/images/pictograms/workexperience.svg"

const spec = [
    {
        title: "Innovation",
        text: "We provide soft skills and entrepreneurship training to help students succeed in fast paced startup and corporate life.",
        alt: "Innovation pictorial",
        image: innovationPic
    },
    {
        title: "Developer skills",
        text: "We teach leading edge tech like Bots and Cross Platform dev that organizations need.",
        alt: "Developer skills pictorial",
        image: devskillsPic
    },
    {
        title: "Work experience",
        text: "We facilitate work placement with partner companies so students can put their skills to practice.",
        alt: "Work experience pictorial",
        image: workexperiencePic
    }
]

function Pictorial(specItem : any) {
    return (
        <div className="col-lg-4 px-lg-5">
            <img className="pictorial py-5" src={specItem.image} alt={specItem.alt}/>
            <h4 className="font-category">
                {specItem.title.toUpperCase()}
            </h4>

            <p className="mb-lg-3 font-description">
                {specItem.text}
            </p>
        </div>
    )
}

function About() {
    return (
        <div className="about bg-light-gray container-fluid py-5">
            <h1 className="">What is MSA?</h1>
            <h3 className="col-12 font-thin">
                MSA is all about helping kiwi students launch their career in IT with Microsoft’s help.
            </h3>
            <div className="container-fluid row no-margin">
                {
                    spec.map((specItem, i) => {
                        return (
                            <Fragment key={i}>
                                {Pictorial(specItem)}
                            </Fragment>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default About;